export const DARK_RELEASE_VARIANT = 70;
export const INTERNAL_INFO_CUSTOM_LOGIC_VARIANT = 38;
export const ADDRESS_SUBFIELD_LOGIC_VARIANT = DARK_RELEASE_VARIANT;
export const VIRTUAL_SESSION_VARIANT = 41;
export const ELOQUA_INTEGRATION_RELEASE_VARIANT = 45;
export const REG_SUMMARY_RELEASE_VARIANT = 46;
export const RELATED_CONTACT_RELEASE_VARIANT = 47;
export const GUESTS_AGENDA_RELEASE_VARIANT = 47;
export const LIVESTREAM_RELEASE_VARIANT = 48;
export const RECOGNIZE_KNOWN_INVITEE = 48;
export const VIRTUAL_LINK_AND_PASSWORD_RELEASE_VARIANT = 48;
